import { create } from "zustand";
import { persist } from "zustand/middleware";

import type { User } from "@/features/auth/types";

interface AuthState {
  token: string | null;
  user: User | null;
  setSession: (token: string, user: User) => void;
  clearSession: () => void;
  setUser: (user: User) => void;
}

const TOKEN_KEY = "oneshift_token";

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      setSession: (token, user) => {
        localStorage.setItem(TOKEN_KEY, token);
        set({ token, user });
      },
      clearSession: () => {
        localStorage.removeItem(TOKEN_KEY);
        set({ token: null, user: null });
      },
      setUser: (user) => set({ user }),
    }),
    {
      name: "oneshift-auth",
      partialize: (state) => ({ user: state.user, token: state.token }),
    },
  ),
);
